import React from 'react';
import ReactDOM from 'react-dom';
import { NODE_ID_KEYS } from '@/constants';

interface PortalProps {
	children: React.ReactNode;
	elementId?: string;
}

export const Portal: React.FC<PortalProps> = ({ children, elementId }) => {
	const [isClientSide, setIsClientSide] = React.useState(false);

	React.useEffect(() => setIsClientSide(true), []);

	return (
		<>
			{isClientSide
				? ReactDOM.createPortal(
						children,
						document.getElementById(
							elementId ?? NODE_ID_KEYS.APP,
						) as HTMLElement,
				  )
				: null}
		</>
	);
};
